import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const WhoWeArePage = lazy(() => import('../pages/who-we-are/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const IndustriesPage = lazy(() => import('../pages/industries/page'));
const CaseStudiesPage = lazy(() => import('../pages/case-studies/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/who-we-are',
    element: <WhoWeArePage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/industries',
    element: <IndustriesPage />
  },
  {
    path: '/case-studies',
    element: <CaseStudiesPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
